<ef-loading-container [observables]="[checkups$]" [loadingText]="loadingText"></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="p-reset">
    <ef-checkup-presenter
        [checkups]="checkups$ | async"
        [processes]="processes$ | async"
    ></ef-checkup-presenter>
</div>
